<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">
      <!-- Brand logo-->
      <b-link class="brand-logo">
        <vuexy-logo />

        <h2 class="brand-text text-primary ml-1">AddCo</h2>
      </b-link>
      <!-- /Brand logo-->

      <!-- Left Text-->
      <b-col lg="8" class="d-none d-lg-flex align-items-center p-5">
        <div
          class="w-100 d-lg-flex align-items-center justify-content-center px-5"
        >
          <!-- <b-img fluid :src="imgUrl" alt="Register V2" /> -->
          <img src="/logo-new.png" alt="Logo" style="width: 10rem; height: 10rem;">
        </div>
      </b-col>
      <!-- /Left Text-->

      <!-- Register-->
      <b-col lg="4" class="d-flex align-items-center auth-bg px-2 p-lg-5">
        <b-col sm="8" md="6" lg="12" class="px-xl-2 mx-auto">
          <b-card-title class="mb-1"> Adventure starts here 🚀 </b-card-title>
          <b-card-text class="mb-2">
            Make your app management easy and fun!
          </b-card-text>

          <!-- form -->
          <validation-observer ref="registerForm" #default="{ invalid }">
            <b-form class="auth-register-form mt-2" @submit.prevent="register">
              <!-- username -->
              <b-form-group label="Username" label-for="register-username">
                <validation-provider
                  #default="{ errors }"
                  name="Username"
                  vid="username"
                  rules="required"
                >
                  <b-form-input
                    id="register-username"
                    v-model="username"
                    name="register-username"
                    :state="errors.length > 0 ? false : null"
                    placeholder="johndoe"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- username -->
              <b-form-group label="Project" label-for="register-project">
                <validation-provider
                  #default="{ errors }"
                  name="Project"
                  vid="project"
                  rules="required"
                >
                  <b-form-input
                    id="register-project"
                    v-model="project"
                    name="register-project"
                    :state="errors.length > 0 ? false : null"
                    placeholder="Project name"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- email -->
              <b-form-group label="Email" label-for="register-email">
                <validation-provider
                  #default="{ errors }"
                  name="Email"
                  vid="email"
                  rules="required|email"
                >
                  <b-form-input
                    id="register-email"
                    v-model="userEmail"
                    name="register-email"
                    :state="errors.length > 0 ? false : null"
                    :placeholder="$t('message.email_example')"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- password -->
              <b-form-group label-for="register-password" label="Password">
                <validation-provider
                  #default="{ errors }"
                  name="Password"
                  vid="password"
                  rules="required"
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid' : null"
                  >
                    <b-form-input
                      id="register-password"
                      v-model="password"
                      class="form-control-merge"
                      :type="passwordFieldType"
                      :state="errors.length > 0 ? false : null"
                      name="register-password"
                      placeholder="············"
                    />
                    <b-input-group-append is-text>
                      <feather-icon
                        :icon="passwordToggleIcon"
                        class="cursor-pointer"
                        @click="togglePasswordVisibility"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <b-form-group>
                <b-form-checkbox
                  id="register-privacy-policy"
                  v-model="status"
                  name="checkbox-1"
                >
                  I agree to
                  <b-link>privacy policy & terms</b-link>
                </b-form-checkbox>
              </b-form-group>

              <b-button
                variant="primary"
                block
                type="submit"
                :disabled="invalid"
              >
                Sign up
              </b-button>
            </b-form>
          </validation-observer>

          <p class="text-center mt-2">
            <span>Already have an account?</span>
            <b-link :to="{ name: 'auth-login' }">
              <span>&nbsp;Sign in instead</span>
            </b-link>
          </p>

          <!-- divider -->
          <div class="divider my-2">
            <div class="divider-text">or</div>
          </div>

          <div class="auth-footer-btn d-flex justify-content-center">
            <b-button variant="facebook" href="javascript:void(0)">
              <feather-icon icon="FacebookIcon" />
            </b-button>
            <b-button variant="twitter" href="javascript:void(0)">
              <feather-icon icon="TwitterIcon" />
            </b-button>
            <b-button variant="google" href="javascript:void(0)">
              <feather-icon icon="MailIcon" />
            </b-button>
            <b-button variant="github" href="javascript:void(0)">
              <feather-icon icon="GithubIcon" />
            </b-button>
          </div>
        </b-col>
      </b-col>
      <!-- /Register-->
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from "vee-validate";
import VuexyLogo from "@core/layouts/components/Logo.vue";
import {
  BRow,
  BCol,
  BLink,
  BButton,
  BForm,
  BFormCheckbox,
  BFormGroup,
  BFormInput,
  BInputGroup,
  BInputGroupAppend,
  BImg,
  BCardTitle,
  BCardText,
} from "bootstrap-vue";
import { required, email } from "@validations";
import { togglePasswordVisibility } from "@core/mixins/ui/forms";
import store from "@/store/index";
import useJwt from "@/auth/jwt/useJwt";

import { getHomeRouteForLoggedInUser } from "@/auth/utils";

import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import axios from "@axios";
import { queryUser } from "@/@core/queries/user";

export default {
  components: {
    VuexyLogo,
    BRow,
    BImg,
    BCol,
    BLink,
    BButton,
    BForm,
    BCardText,
    BCardTitle,
    BFormCheckbox,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      status: "",
      username: "",
      project: "",
      userEmail: "",
      password: "",
      sideImg: require("@/assets/images/pages/register-v2.svg"),
      required,
      email,
    };
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === "password" ? "EyeIcon" : "EyeOffIcon";
    },
    imgUrl() {
      if (store.state.appConfig.layout.skin === "dark") {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require("@/assets/images/pages/register-v2-dark.svg");
        return this.sideImg;
      }
      return this.sideImg;
    },
  },
  methods: {
    register() {
      // this.$refs.registerForm.validate().then((success) => {
      //   if (success) {
      //     useJwt
      //       .register({
      //         username: this.username,
      //         email: this.userEmail,
      //         password: this.password,
      //       })
      //       .then(async () => {
      //         try {
      //           const logUser = await useJwt.login({
      //             email: this.userEmail,
      //             password: this.password,
      //           });
      //           useJwt.setToken(logUser.accessToken);
      //           useJwt.setRefreshToken(logUser.refreshToken);
      //           axios
      //             .post("/graphql", {
      //               query: queryUser,
      //               variables: { query: { id: logUser.id } },
      //             })
      //             .then(async(response) => {
      //               await useJwt.updateDefaultData({
      //                 id: logUser.id,
      //                 username: this.username,
      //                 project: this.project,
      //                 client_id: response.data.data.user._id
      //               });
      //               await useJwt.realm.currentUser.refreshCustomData();
      //               const {
      //                 custom_data: {
      //                   ability,
      //                   role,
      //                   username,
      //                   extras,
      //                   project = "",
      //                   worker_id = null, // for consultant & supervisor
      //                   client_id = null, // for all users
      //                 },
      //               } = useJwt.realm.currentUser.customData;
      //               const { id } = useJwt.realm.currentUser;
      //               this.$ability.update(ability);
      //               const userData = {
      //                 id,
      //                 fullName: username || "",
      //                 username,
      //                 avatar: require("@/assets/images/avatars/13-small.png"),
      //                 email: this.userEmail,
      //                 role,
      //                 ability,
      //                 extras,
      //                 project: project || "",
      //                 worker_id,
      //                 client: client_id || null,
      //               };
      //               localStorage.setItem("userData", JSON.stringify(userData));
      //               this.$store.commit("userStore/updateUserData", userData);
      //               this.$router
      //                 .replace(getHomeRouteForLoggedInUser(role))
      //                 .then(() => {
      //                   this.$toast({
      //                     component: ToastificationContent,
      //                     position: "top-right",
      //                     props: {
      //                       title: `Welcome ${username || ""}`,
      //                       icon: "CoffeeIcon",
      //                       variant: "success",
      //                       text: `You have successfully signed up as ${role}. Now you can start to explore!`,
      //                     },
      //                   });
      //                 });
      //             })
      //             .catch((err) => {
      //               console.log(err);
      //             });
      //         } catch (e) {
      //           console.error(e);
      //         }
      //       })
      //       .catch((error) => {
      //         const errors = {
      //           password: [],
      //           email: [],
      //         };
      //         if (error.errorCode === "InvalidPassword") {
      //           errors.password = [error.error];
      //         }
      //         if (error.errorCode === "AccountNameInUse") {
      //           errors.email = [error.error.replace("name", "Email")];
      //         }
      //         this.$refs.registerForm.setErrors(errors);
      //       });
      //   }
      // });
    },
  },
};
/* eslint-disable global-require */
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-auth.scss";
</style>
